module.exports = __webpack_public_path__ + "media/images/icons/flags/LR-f2a9d9ff5a5480c89d24273e62f6668d.svg";